import "./ResourceShowcasePage.scss";
import CheckmarkIcon from "../icons/content-pages/CheckmarkIcon";
import { useEffect } from "react";
import { UnorderedListOutlined } from "@ant-design/icons";

export default function ResourceShowcasePage() {
  useEffect(() => {
    let meta = document.createElement('meta');
    meta.name = "robots";
    meta.content = "noindex";
    document.getElementsByTagName('head')[0].prepend(meta);
  }, [])
  
  return (
  <main className="resource-showcase-content">
    <section className={"one"}>
      <div className="content">
        <div className={"flex reverse"}>
          <div className={"half text"}>
            <h1 className={"mobile-only"}>Who is MustHaveMenus?</h1>
          </div>
          <div className={"half video"}>
            <iframe width="550" height="315" src="https://www.youtube.com/embed/eJdpy_2DjI0" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </div>
          <div className={"half text"}>
            <h1 className={"desktop-only"}>Who is MustHaveMenus?</h1>
            <p>
              For 10+ years, MustHaveMenus has provided restaurants with all their design, marketing and printing needs. Everything you need to market your restaurant, right at your fingertips.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className={"two"}>
      <div className="content">
        <h2>MustHaveMenus Differentiators</h2>
        <div className={"flex"}>
          <div className={"half"}>
            <ul>
              <li>
                <div><img src="https://timber.mhmcdn.com/site/marketing/icons/DesignSets.svg" alt="Design Sets"/></div>
                <div>
                  <p>World's Largest Menu Collection</p>
                  <p>Over 25,000 customizable templates and counting.</p>
                </div>
              </li>
              <li>
                <div><img src="https://timber.mhmcdn.com/site/marketing/icons/Megaphone.svg" alt="Megaphone"/></div>
                <div>
                  <p>One-stop Shop</p>
                  <p>All your restaurant marketing materials like flyers, posters, business cards, and more in one convenient location.</p>
                </div>
              </li>
              <li>
                <div className={"small-icon"}><img src="https://timber.mhmcdn.com/site/marketing/icons/QRCode.svg" alt="QR Code"/></div>
                <div>
                  <p>Digital Tools</p>
                  <p>Share your designs with the world using our dynamic QR codes and sharelinks.</p>
                </div>
              </li>
              <li>
                <div><img src="https://timber.mhmcdn.com/site/marketing/icons/OnlineMenus.svg" alt="Online Menus"/></div>
                <div>
                  <p>Made for Restaurants</p>
                  <p>All products, print or otherwise, are tailored to the specific needs of the food industry.</p>
                </div>
              </li>
              <li>
                <div className={"small-icon"}><img src="https://timber.mhmcdn.com/site/marketing/icons/Star.svg" alt="Star"/></div>
                <div>
                  <p>Free-to-Try Options</p>
                  <p>We know budgets are tight, so we offer a robust Free Program that's not hidden behind a paywall.</p>
                </div>
              </li>
              <li>
                <div className={"small-icon"}><img src="https://timber.mhmcdn.com/site/marketing/icons/CustomerService.svg" alt="CS"/></div>
                <div>
                  <p>Expert Customer Support</p>
                  <p>Friendly customer service experts are ready to help resolve any issue, usually in a matter of minutes.</p>
                </div>
              </li>
            </ul>
          </div>
          <div className={"half"}>
            <ul>
              <li>
                <div><img src="https://timber.mhmcdn.com/site/marketing/icons/Printer.svg" alt="Printer"/></div>
                <div>
                  <p>The Print Pros</p>
                  <p>Printing done right for restaurants. Covers a variety of products like sandwich boards, folded takeout menus, and business cards. Plus you have the option for high-quality finishes and laminates.</p>
                </div>
              </li>
              <li>
                <div className={"small-icon"}><UnorderedListOutlined/></div>
                <div>
                  <p>POS Integrations</p>
                  <p>Seamlessly pull data from POS providers into your designs. Keep all your data synced with our Design Updater.</p>
                </div>
              </li>
              <li>
                <div className={"small-icon"}><img src="https://timber.mhmcdn.com/site/marketing/icons/DigiBoard.svg" alt="DMBs"/></div>
                <div>
                  <p>Digital Menu Boards</p>
                  <p>Create digital menus and signage for various screen sizes. Simple to design, display and update.</p>
                </div>
              </li>
              <li>
                <div><img src="https://timber.mhmcdn.com/site/marketing/icons/Hospitality.svg" alt="Menu Services"/></div>
                <div>
                  <p>Menu Services</p>
                  <p>Menu Services can create professional menu designs using your data for only $199/page.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section className={"three"}>
      <div className="content">
        <h2>Customer Journey</h2>
        <img src={'https://timber.mhmcdn.com/site/content/resource-showcase/CustomerJourney.webp'} alt={"Customer Journey"}/>
        <div className={"flex"}>
          <div className={"item"}>
            <div>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/ChooseTemplate.svg" alt="Choose template"/>
            </div>
            <h3>Choose a Template</h3>
            <p>
              Pick from over 25,000 templates for <a href="/menu/browse.do">menus</a>, <a href="/category/takeout-menus.html">takeouts</a>, <a href="/category/restaurant-flyer.html">flyers</a>, <a href="/category/table-tent.html">tents</a>, <a href="/category/business-cards.html">cards</a>, <a href="/category/restaurant-posters.html">posters</a>, <a href="/category/stickers.html">stickers</a> and more.
            </p>
          </div>
          <div className={"arrow"}>
            <img src="https://timber.mhmcdn.com/site/marketing/icons/Arrow.svg" alt="Arrow"/>
          </div>
          <div className={"item"}>
            <div>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="Paintbrush"/>
            </div>
            <h3>Customize</h3>
            <p>
              Use our easy <a href="/feature/menu-maker.html">menu maker</a> to add your menu items, change fonts, styles and more. 
            </p>
          </div>
          <div className={"arrow"}>
            <img src="https://timber.mhmcdn.com/site/marketing/icons/Arrow.svg" alt="Arrow"/>
          </div>
          <div className={"item"}>
            <div>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/QRCode.svg" alt="QR Code"/>
            </div>
            <h3>Create Links</h3>
            <p>
              Share your designs with your customers and followers.
            </p>
          </div>
          <div className={"arrow"}>
            <img src="https://timber.mhmcdn.com/site/marketing/icons/Arrow.svg" alt="Arrow"/>
          </div>
          <div className={"item"}>
            <div>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/Printer.svg" alt="Printer"/>
            </div>
            <h3>Print</h3>
            <p>
              Enjoy restaurant-quality printing of menus, signage, marketing and more.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className={"four"}>
      <div className="content">
        <div className={"flex"}>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/MenuSet.webp"} alt="Menu Set"/>
          </div>
          <div className={"half"}>
            <h2>Membership Plans</h2>
            <p>
              <b>Free Access:</b> Ability to customize thousands of templates, download designs, and use QR codes.
            </p>
            <p>
              <b>7-day Free Trial:</b> Access to all pro features for 7 days. No card info required.
            </p>
            <p>
              <b>Paid Pro:</b> Access to every single template and feature. Upgrades from free trial to paid automatically after 7 days.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className={"five"}>
      <div className="content">
        <div className={"flex reverse"}>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/PrintServices.webp"} alt="Print Services"/>
          </div>
          <div className={"half"}>
            <h2>Print Services</h2>
            <p>
              MustHaveMenus offers professional-quality printing for restaurants directly within our design app. It's just one click to all the options you'd expect from a top printer. We handle over 10,000 prints job a year across 14 different print products:
            </p>
            <div className={"list-holder"}>
              <ul>
                <li>Traditional Menus</li>
                <li>Takeout Menus</li>
                <li>Half Page Menus</li>
                <li>Flyers</li>
                <li>Table Tents</li>
                <li>Kids Menus</li>
                <li>Posters</li>
              </ul>
              <ul>
                <li>Business Cards</li>
                <li>Loyalty Cards</li>
                <li>Stickers & Labels</li>
                <li>Sandwich Boards</li>
                <li>Gift Certificates</li>
                <li>Comment Cards</li>
                <li>Rack Cards</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className={"six"}>
      <div className="content">
        <div className={"flex"}>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/CustomerCare.webp"} alt="Customer Care"/>
          </div>
          <div className={"half"}>
            <h2>Customer Care</h2>
            <p>Unlike most online companies, we employ a real customer service team to support our restaurants at every stage of the process. From choosing a template to nailing the design, our team of friendly customer service experts are here to help create your dream design.</p>
          </div>
        </div>
      </div>
    </section>

    <section className={"seven"}>
      <div className="content">
        <h2>Features & Benefits</h2>
        <div className={"flex"}>
          <div className={"column"}>
            <h3>Design</h3>
            <ul>
              <li>
                <CheckmarkIcon/>
                <div>20,000+ templates</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Eye-dropper and gradient tools</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Combine multiple designs</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Ruler guide for easy formatting</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Brand management tool</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Custom fonts</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Column controls</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Highlight boxes</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Item layouts</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Document resizing</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Change backgrounds</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>1 million+ image library</div>
              </li>
            </ul>
          </div>
          <div className={"column"}>
            <h3>Printing</h3>
            <ul>
              <li>
                <CheckmarkIcon/>
                <div>Restaurant-proof papers</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Menu lamination</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Folded takeouts come ready-to-use</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Standard 12pt cardstock for a weighty feel</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Next-day shipping</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Print helper for satisfaction guarantee</div>
              </li>
            </ul>
          </div>
          <div className={"column"}>
            <h3>Digital</h3>
            <ul>
              <li>
                <CheckmarkIcon/>
                <div>QR codes for any design</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Online menus</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Link pages for your socials</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Free social media posts for every occasion</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Provide the best mobile experience</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Easy to update and share</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Reach new customers wherever, whenever</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>All digital tools connect seamlessly with printed ones</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Campaigns can be pushed live in minutes</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Encourage more online orders</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>Measure and track what works</div>
              </li>
              <li>
                <CheckmarkIcon/>
                <div>All digital tools are free to use</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section className={"eight"}>
      <div className="content">
        <div className={"flex reverse"}>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/ReferralImage.webp"} alt="Referral"/>
          </div>
          <div className={"half"}>
            <h2>Affiliate Program</h2>
            <p><b>Get 10% revenue share on all subscription and print revenue!</b></p>
            <p>
              Interested in becoming one of our trusted affiliates? For every customer you turn on to the magic of MustHaveMenus, you can earn your business extra money and perks.
            </p>
            <a href={"/content/affiliate"} className={"ant-btn ant-btn-primary ant-btn-lg"}>Become an Affiliate</a>
          </div>
        </div>
      </div>
    </section>

    <section className={"nine"}>
      <div className="content">
        <h2>Video Resources</h2>
        <div className={"flex"}>
          <div>
            <iframe width="352" height="200" src="https://www.youtube.com/embed/eJdpy_2DjI0" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            <p>MustHaveMenus Overview</p>
          </div>
          <div>
            <iframe width="352" height="200" src="https://www.youtube.com/embed/L-WdCIXZWY0" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            <p>The Menu Maker</p>
          </div>
          <div>
            <iframe width="352" height="200" src="https://www.youtube.com/embed/PG-r-xipzbc" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            <p>Design Templates</p>
          </div>
          <div>
            <iframe width="352" height="200" src="https://www.youtube.com/embed/K3G0gfOVfCk" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            <p>Printing</p>
          </div>
          <div>
            <iframe width="352" height="200" src="https://www.youtube.com/embed/U5dvIyfzXVQ" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            <p>Digital Tools</p>
          </div>
          <div>
          </div>
        </div>
      </div>
    </section>

    <section className={"ten"}>
      <div className="content">
        <h2>Sales Sheets</h2>
        <div className={"flex"}>
          <div>
            <a href="https://timber.mhmcdn.com/site/salessheets/01%20MHM%20Sales%20Sheet%20Overview.pdf" target="_blank" rel="noreferrer">
              <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialOverview.webp"} alt={"Overview Preview"}/>
            </a>
            <p>Overview</p>
          </div>
          <div>
            <a href="https://timber.mhmcdn.com/site/salessheets/02%20MHM%20Sales%20Sheet%20The%20Menu%20Maker.pdf" target="_blank" rel="noreferrer">
              <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialMenuMaker.webp"} alt={"Menu Maker Preview"}/>
            </a>
            <p>The Menu Maker</p>
          </div>
          <div>
            <a href="https://timber.mhmcdn.com/site/salessheets/03%20MHM%20Sales%20Sheet%20Digital%20Tools%20A.pdf" target="_blank" rel="noreferrer">
              <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialDigitalTools.webp"} alt={"Digital Tools Preview"}/>
            </a>
            <p>Digital Tools</p>
          </div>
          <div>
            <a href="https://timber.mhmcdn.com/site/salessheets/04%20MHM%20Sales%20Sheet%20Printing.pdf" target="_blank" rel="noreferrer">
              <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialPrinting.webp"} alt={"Printing Preview"}/>
            </a>
            <p>Printing</p>
          </div>
          <div>
            <a href="https://timber.mhmcdn.com/site/salessheets/05%20MHM%20Sales%20Sheet%20Testimonials.pdf" target="_blank" rel="noreferrer">
              <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialTestimonials.webp"} alt={"Testimonials Preview"}/>
            </a>
            <p>Testimonials</p>
          </div>
        </div>
      </div>
    </section>
  </main>)
}
